import { render, staticRenderFns } from "./plagas.vue?vue&type=template&id=35952510&scoped=true&"
import script from "./plagas.vue?vue&type=script&lang=js&"
export * from "./plagas.vue?vue&type=script&lang=js&"
import style0 from "./plagas.vue?vue&type=style&index=0&id=35952510&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35952510",
  null
  
)

export default component.exports